import React, { useState } from 'react';
import styled from 'styled-components';
import { FaBars } from 'react-icons/fa'; // Using Font Awesome for the hamburger icon

const HeaderContainer = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 10rem;
  background-color: #fff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    padding: 0.5rem 2rem;
  }
`;

const Logo = styled.div`
  display: flex;
  align-items: center;

  img {
    height: 40px;
    margin-right: 10px;

    @media (max-width: 768px) {
      height: 30px;
    }
  }

  h1 {
    font-size: 24px;
    font-weight: bold;
    color: #333;

    @media (max-width: 768px) {
      font-size: 20px;
    }
  }
`;

const NavLinks = styled.nav`
  display: flex;
  margin-left: auto; /* Moves the links to the right */

  a {
    margin: 0 15px;
    text-decoration: none;
    color: #333;
    font-weight: 600;
    font-size: 18px;

    &:hover {
      color: rgb(88, 199, 192);
    }
  }

  @media (max-width: 768px) {
    display: ${(props) => (props.showMenu ? 'block' : 'none')};
    position: absolute;
    top: 60px;
    right: 10px;
    background-color: #fff;
    padding: 1rem;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
    border-radius: 5px;

    a {
      display: block;
      margin: 10px 0;
    }
  }
`;

const HamburgerIcon = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
    font-size: 24px;
    cursor: pointer;
  }
`;

const Header = () => {
  const [showMenu, setShowMenu] = useState(false);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  return (
    <HeaderContainer>
      {/* Logo */}
      <Logo>
        <img src="/Sproutronlogo.ico" alt="Sproutron Labs Logo" />
        <h1>SPROUTRON LABS</h1>
      </Logo>

      {/* Hamburger Icon for Mobile */}
      <HamburgerIcon onClick={toggleMenu}>
        <FaBars />
      </HamburgerIcon>

      {/* Navigation Links */}
      <NavLinks showMenu={showMenu}>
        <a href="#keyvalue">Features</a>
        <a href="#Pricing">Pricing</a>
      </NavLinks>
    </HeaderContainer>
  );
};

export default Header;
